import { CheckoutContract } from '../../models/checkout/checkout-contract.interface';
import { mockCheckoutAttribute } from './checkout-atttribute.mock';

export const mockCheckoutContract: CheckoutContract = {
  attributes: [mockCheckoutAttribute],
  isMultiplan: false,
};
